import { createFileRoute } from '@tanstack/react-router';
import DocsGroupHome from '@/components/Docs/DocsGroupHome';

export const Route = createFileRoute('/docs/')({
  component: DocsHomePage,
});

function DocsHomePage() {
  return <DocsGroupHome group="documentation" />;
}
